import assert from "assert";
import type { App } from "../app/app.js";

export type MessageData = {
	to: string;
	subject: string;
	html: string;
	attachments: any[];
	text: string;
	replyTo?: string;
};

export default class Message {
	data: MessageData;
	constructor(data: MessageData) {
		assert(data.to);
		assert(data.subject);
		assert(data.html);
		assert(
			data.attachments === undefined || Array.isArray(data.attachments)
		);
		this.data = data;
	}
	async send(app: App): Promise<void> {
		return app.mailer.send(this.data);
	}
}
